import axios from 'axios';
// config
import { HOST_API } from '../config';
import Cookies from 'js-cookie';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
  headers: {
    Authorization: `Bearer ${Cookies.get('careflowToken')}`,
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
